import React from "react";
import { useShow } from "@refinedev/core";
import { Show } from "@refinedev/antd";
import { Card, Descriptions, Tag, Table } from "antd";
import dayjs from 'dayjs';
import { DEFAULT_COMMITTEE_ONE_QUERY } from "./queries";
import { IDefaultCommittee } from "./interface";

export const DefaultCommitteeShow: React.FC = () => {
  const { query } = useShow<IDefaultCommittee>({
    resource: "defaultCommittees",
    meta: {
      gqlQuery: DEFAULT_COMMITTEE_ONE_QUERY,
    },
  });

  const { data, isLoading } = query;
  const record = data?.data;

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!record) {
    return <div>Default committee not found</div>;
  }

  const memberColumns = [
    {
      title: "Full Name",
      dataIndex: "fullName",
      key: "fullName",
    },
    {
      title: "Role",
      dataIndex: "role",
      key: "role",
      render: (role: string) => role.toLowerCase().replace("_", " "),
    },
    {
      title: "Organization",
      dataIndex: "organization",
      key: "organization",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "isActive",
      render: (isActive: boolean) => (
        <Tag color={isActive ? "success" : "error"}>
          {isActive ? "Active" : "Inactive"}
        </Tag>
      ),
    },
  ];

  return (
    <Show title="Default Committee Details">
      <Card>
        <Descriptions column={2} layout="vertical" bordered>
          <Descriptions.Item label="Committee Name">
            {record.name}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={record.isActive ? "success" : "error"}>
              {record.isActive ? "Active" : "Inactive"}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Applicable Minute Types" span={2}>
            {record.applicableMinuteTypes?.map((type) => (
              <Tag key={type} color="blue">
                {type.toLowerCase().replace("_", " ")}
              </Tag>
            ))}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {dayjs(record.createdAt).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
          <Descriptions.Item label="Updated At">
            {dayjs(record.updatedAt).format('YYYY-MM-DD HH:mm')}
          </Descriptions.Item>
        </Descriptions>

        <Card title="Committee Members" style={{ marginTop: 16 }}>
          <Table
            dataSource={record.members}
            columns={memberColumns}
            rowKey={(record, index) => (index ?? Date.now() + Math.random()).toString()}
            bordered
            pagination={false}
          />
        </Card>
      </Card>
    </Show>
  );
};
